import DocumentUtils from './DocumentUtils';
import WrapperMessageDispatcher from './WrapperMessageDispatcher';
export default class FramePropertyPoll {
    static start() {
        if (!FramePropertyPoll.shouldFramePoll()) {
            return;
        }
        FramePropertyPoll.setInitialHeight();
        FramePropertyPoll.pollIntervalID = window.setInterval(FramePropertyPoll.maybeUpdateDocumentProperties, 200);
    }
    static stop() {
        if (!FramePropertyPoll.shouldFramePoll()) {
            return;
        }
        clearInterval(FramePropertyPoll.pollIntervalID);
    }
    static maybeUpdateDocumentProperties() {
        FramePropertyPoll.maybeUpdateHeight();
    }
    static setInitialHeight() {
        FramePropertyPoll.height = DocumentUtils.getDocumentHeight();
        FramePropertyPoll.dispatchHeightChange(FramePropertyPoll.height);
    }
    static maybeUpdateHeight() {
        const newHeight = DocumentUtils.getDocumentHeight();
        if (FramePropertyPoll.height !== newHeight) {
            FramePropertyPoll.dispatchHeightChange(newHeight);
            FramePropertyPoll.height = newHeight;
        }
    }
    static shouldFramePoll() {
        return typeof (window.top) !== 'undefined';
    }
    static dispatchHeightChange(newHeight) {
        WrapperMessageDispatcher.dispatchMessage('height_change', { height: newHeight });
    }
}
//# sourceMappingURL=FramePropertyPoll.js.map